var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"countDown",staticClass:"count-down",class:{'count-down-text-indent' : _vm.count},on:{"click":_vm.handleTouchend}},[_vm._v("\n  "+_vm._s(_vm.count ? _vm.count: _vm.message)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6106d82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountDown/index.vue
// module id = null
// module chunks = 